import {createRequest, makeRequest, prepareRequest} from "../utils/apiUtil";

export function getAll(filters = {}, includes = [], extraParams = {}) {
    return makeRequest(createRequest('facility'), prepareRequest(filters, includes, extraParams));
}